// CORE
import React from 'react';
import styled from 'styled-components';

// COMPONENTS
// import { ToolTip } from '../../../components/ToolTip';

// STYLES
import { black400 } from '../../../theme/colors';
import { defaultFont, smallFont } from '../../../theme/typography';
import LoginLogo from "../../dashboard/retail-hub-logo.png"

import {
    ImageMobileStyle, secureSectionContainer,
    secureItem,
    secureLogo,
    secureTextContainer,
    secureTitle,
    secureSubtitle, secureLogo_Shield, secureLogo_iso
} from "../../../theme/commonStyles";
// ICONS
// import ContactSupportIcon from '@material-ui/icons/ContactSupport';

export const sectionSpace = styled.div`
   
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 10px;
    margin: 0 64px; 
    width: calc(100% - 128px);

    p {
        ${(props) => (props.textStyle !== null ? smallFont : defaultFont)};
        width: 100%;
        color: ${black400};
    a {
            color: #5ba4e5;
            ${(props) => (props.textStyle !== null ? smallFont : defaultFont)};
        }
    }

    svg {
        width: 43px;
        height: 43px;
        align-content: flex-end;
    }
    
`;
export const FooterStyle = styled.div`
display: flex;
flex-direction: row;
margin-bottom: 2%;


`;

const FooterMobile = (props) => {
    return <FooterStyle>
        <sectionSpace style={{ flexDirection: "flex", alignItems: "center", textAlign: "center" , width: "100%"}}>
            <img src={LoginLogo} alt='logo' height="45px" width="160px" style={{ marginBottom: "25px", display: "block", marginLeft: "auto", marginRight: "auto" }} />

            {props.showSecuritySection == true && (
                <div style={secureSectionContainer}>
                    <div style={secureItem}>
                        <img
                            src="/favicons/pci_dss.png"
                            alt="SSL Lock Logo"
                            style={secureLogo}
                        />
                    </div>

                    <div style={secureItem}>
                        <img
                            src="/favicons/iso_informationsecurity.png"
                            alt="ISO Logo"
                            style={secureLogo_iso}
                        />
                        <div style={secureTextContainer}>
                            <p style={secureTitle}>ISO</p>
                            <p style={secureSubtitle}>27001</p>
                        </div>
                    </div>

                    <div style={secureItem}>
                        <img
                            src="/favicons/shield.png"
                            alt="Encryption Logo"
                            style={secureLogo_Shield}
                        />
                        <div style={secureTextContainer}>
                            <p style={secureTitle}>256 bit</p>
                            <p style={secureSubtitle}>encrypted</p>
                        </div>
                    </div>
                </div>
            )}

            <p style={{ alignSelf: "center", textAlign: "center" }}>
                Copyright. Retail Scan Management Services Pvt Ltd {new Date().getFullYear()}{' '}<br />
                <a 
                href="https://www.retail-scan.com/terms-and-condition.html"
                style={{ color: "#5ba4e5" }}>Terms and conditions</a> & <a 
                href="https://www.retail-scan.com/privacy-policy.html"
                style={{ color: "#5ba4e5" }}>Privacy Policy</a>
            </p>
        </sectionSpace>
        {/* <ToolTip icon={<ContactSupportIcon />} content={"FAQ"} align={"top center"} /> */}
    </FooterStyle>
}

export default FooterMobile;